import React from 'react';
import { Box, Typography, TableCell, styled } from '@mui/material';
import RoutineStyle from "../../../components/GlobalPolicies/RoutineUpload.module.css";
import profileImg from '../../../assets/SVGs/profile_pic.svg';





const StyledTableRow = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
}));
interface UserDetailsTableProps {
  userName?: string;
  date: string;
  functionl1?: string;
  functionl2?: string;
  functionl3?: string;
  current_project?: string;
  // created_by?: string;
  data?:any; // Receive data as a prop
  updatedBy?:any;
}

const UserDetailsTable: React.FC<UserDetailsTableProps> = ({ userName, date, functionl1, current_project, functionl2, functionl3, data, updatedBy }) => {

  console.log('datadatadatadatadata', data)

  return (
    <Box sx={{ padding: '16px' }}>
      <StyledTableRow sx={{ boxShadow: '0px 1px 0px 0px rgba(0, 0, 0, 0.10)' }}>
        {current_project && (
          <TableCell sx={{ border: 0 }}>
            <Typography className={RoutineStyle.userDetail}>Name of the project</Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
              <span color='#000'>{current_project}</span>
            </Box>
          </TableCell>

        )}

        <TableCell sx={{ border: 0 }}>
          <Typography className={RoutineStyle.userDetail}>Updated Date</Typography>
          <Typography variant="body2" color='#000'>{new Date(date).toLocaleDateString()}</Typography>
        </TableCell>

        {functionl1 && (
          <TableCell sx={{ border: 0, width: '150px' }}>
            <Typography className={RoutineStyle.userDetail}>Function L1</Typography>
            <Typography variant="body2" color='#000'>{functionl1 || '---'}</Typography>
          </TableCell>
        )}

        {functionl2 && (
          <TableCell sx={{ border: 0, width: '150px' }}>
            <Typography className={RoutineStyle.userDetail}>Function L2</Typography>
            <Typography variant="body2" color='#000'>{functionl2 || '---'}</Typography>
          </TableCell>
        )}

        {functionl3 && (
          <TableCell sx={{ border: 0, width: '150px' }}>
            <Typography className={RoutineStyle.userDetail}>Function L3</Typography>
            <Typography variant="body2" color='#000'>{functionl2 || '---'}</Typography>
          </TableCell>
        )}




        <TableCell sx={{ border: 0 }}>
          <Typography className={RoutineStyle.userDetail}>Updated By</Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
            {/* <img src={profileImg} alt="" /> */}
            <div>
              {/* <Typography variant="body2" color='#000'>{localStorage.getItem("userName")}</Typography> */}
              <Typography variant="body2" color='#000'>{updatedBy || '---'}</Typography>
              {/* <Typography className={RoutineStyle.userDetail}>{localStorage.getItem("role")}</Typography> */}
            </div>
          </Box>
        </TableCell>
      </StyledTableRow>
    </Box>
  );
};

export default UserDetailsTable;